import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solicitar-permisos',
  templateUrl: './solicitar-permisos.component.html',
  styleUrls: ['./solicitar-permisos.component.scss']
})
export class SolicitarPermisosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
